import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 45 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#98A2B3",
      "fill-rule": "evenodd",
      d: "M10.125 13.792a3.667 3.667 0 1 1 7.333 0 3.667 3.667 0 0 1-7.333 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#98A2B3",
      "fill-rule": "evenodd",
      d: "M22.364 3.25h.273c3.989 0 7.17 0 9.663.335 2.574.346 4.69 1.08 6.362 2.753 1.673 1.672 2.407 3.788 2.753 6.362.335 2.494.335 5.674.335 9.664v.272c0 3.99 0 7.17-.335 9.664-.346 2.574-1.08 4.69-2.753 6.362-1.672 1.673-3.788 2.407-6.362 2.753-2.494.335-5.674.335-9.664.335h-.272c-3.99 0-7.17 0-9.664-.335-2.574-.346-4.69-1.08-6.362-2.753C4.665 36.99 3.93 34.874 3.585 32.3c-.335-2.494-.335-5.674-.335-9.663v-.274c0-3.989 0-7.17.335-9.663.346-2.574 1.08-4.69 2.753-6.362C8.01 4.665 10.126 3.93 12.7 3.585c2.494-.335 5.674-.335 9.664-.335m-9.175 3.97c-2.168.29-3.38.832-4.259 1.71-.878.878-1.42 2.09-1.71 4.259-.3 2.22-.303 5.154-.303 9.311s.004 7.09.302 9.311c.292 2.168.833 3.38 1.711 4.259.878.878 2.09 1.42 4.259 1.71 2.22.3 5.154.303 9.311.303s7.09-.004 9.311-.302c2.168-.292 3.38-.833 4.259-1.711.878-.878 1.42-2.09 1.71-4.259.3-2.22.303-5.154.303-9.311s-.004-7.09-.302-9.311c-.292-2.168-.833-3.38-1.711-4.259-.878-.878-2.09-1.42-4.259-1.71-2.22-.3-5.154-.303-9.311-.303s-7.09.004-9.311.302",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#98A2B3",
      d: "M40.906 23.788c-3.57-2.302-6.97-3.267-10.225-3.13-3.24.134-6.153 1.352-8.774 3.104-4.434 2.965-8.333 7.695-11.825 11.93-.553.67-1.095 1.329-1.628 1.965l-1.538 1.344 2.242 1.527c1.585.656 3.438.944 5.567 1.084 2.121.139 4.676.139 7.715.139h.197c3.99 0 7.17 0 9.663-.335 2.575-.346 4.69-1.08 6.363-2.753 1.466-1.465 2.215-3.264 2.61-5.43.385-2.112.457-4.715.473-7.895l.005-1.005z"
    }, null, -1)
  ])))
}
export default { render: render }